































import { Component, Vue, Prop } from 'vue-property-decorator';
import { STATUS, STATUS_EXPLAINING } from '@/const/status/index';

@Component<ExplainColumn>({
    name: 'ExplainColumn',
})
export default class ExplainColumn extends Vue {
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'left' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 120 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;

    @Prop({ type: String, default: 'status' }) private status!: string;

    private STATUS = STATUS;
    private STATUS_EXPLAINING = STATUS_EXPLAINING;
}
